window.addEventListener('DOMContentLoaded', () => {

    function updateComboTotal() {
    let total = 0;
    document.querySelectorAll('#combo-box .combo-product').forEach(productEl => {
        const checkbox = productEl.querySelector('.combo-check');
        const price = parseFloat(productEl.getAttribute('data-price'));

        if (checkbox.checked) {
        total += price * 1;
        }
    });

    // Apply flat ₹99 discount if both are selected
    const selectedCount = document.querySelectorAll('#combo-box .combo-check:checked').length;
    if (selectedCount >= 2) {
        total = total - 99;
    }

    document.getElementById('combo-total').textContent = total.toFixed(0);
    }

    // Update price when checkboxes or quantities change
    document.querySelectorAll('.combo-check').forEach(el => {
    el.addEventListener('change', updateComboTotal);
    });

    // Trigger once at start
    updateComboTotal();

    document.getElementById('add-combo-to-cart').addEventListener('click', function () {
        const items = [];

        document.querySelectorAll('#combo-box .combo-product').forEach(productEl => {
            const checkbox = productEl.querySelector('.combo-check');
            const variantId = productEl.getAttribute('data-variant-id');

            if (checkbox.checked) {
            items.push({ id: variantId, quantity: 1 });
            }
        });

        if (items.length === 0) {
            alert("Please select at least one product.");
            return;
        }

        this.classList.add('loading');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })

        .then((response) => response.json())
        .then((data) => {
            const autoAddSettings = window.autoAddSettings || {}; // Fallback to empty object
            const autoAddThreshold = autoAddSettings.threshold;
            const autoAddProduct = autoAddSettings.autoAddProduct;
            const collectionProducts = autoAddSettings.collectionProducts;
                            if (typeof autoAddThreshold !== "undefined" && 
            typeof autoAddProduct !== "undefined" && 
            Array.isArray(collectionProducts) && collectionProducts.length > 0) {
            fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                let cartTotal = cart.total_price / 100;
                let hasCollectionProduct = cart.items.some(item => collectionProducts.includes(item.handle));

                console.log("Cart total:", cartTotal);
                console.log("Has collection product:", hasCollectionProduct);

                let productExists = cart.items.some(item => item.id === autoAddProduct);

                if (cartTotal >= autoAddThreshold && hasCollectionProduct && !productExists) {
                    fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            id: autoAddProduct, // Using variant ID instead of product ID
                            quantity: 1
                        })
                    })
                    .then(response => response.json())
                    .then(() => {
                        console.log("Auto-added product to cart");
                    ht("quick-cart:updated");
                    console.log('grid yessss')
                        // location.reload(); // Refresh to update cart
                    })
                    .catch(error => console.error("Error adding product:", error));
                    }
                });
                                }
            this.classList.remove('loading');
            fetch('/cart/?section_id=purchase-confirmation-popup-item', {
                    method: 'GET'
                })
                .then(res => res.text())
                .then(data => {

                
                    // append purchase confirmation popup
                    const productConfirmPopEle = document.querySelector('[data-section-id="quick-cart"]');
                    const productConfirmPopWrapper = document.querySelector('.quick-cart__wrapper');
                    productConfirmPopWrapper.classList.add('active');
                    productConfirmPopEle.classList.add('animation--quick-cart-revealed');

                    window.theme.offerSecSlider();
                    // freeshipping bar
                    this.freeShipStatus('[data-purchase-confirmation-popup] .free-shipping-bar');


                })
                .catch(err => console.error('Error:', err))


            // append data on cart drawer
            fetch('/cart?section_id=quick-cart', {
                    method: 'GET'
                })
                .then(res => res.text())
                .then(data => {

                    const quickCartTrigger = document.querySelector('.quick-cart__container');
                    // Initialize the DOM parser
                    const parser = new DOMParser();
                    const cartData = parser.parseFromString(data, "text/html");
                    const appendData = cartData.querySelector('.quick-cart__container').innerHTML;
                    quickCartTrigger.innerHTML = appendData;

                    // cart count on header
                    const cardCount = parseInt(cartData.querySelector('.quick-cart__heading sup').textContent);
                    if (cardCount) {
                        document.querySelectorAll('[data-js-cart-count]').forEach(counter => {
                            counter.textContent = cardCount;
                        })
                    }

                    // freeshipping bar
                    this.freeShipStatus('.quick-cart .free-shipping-bar');

                })
                .catch(err => console.log('Error:', err))

        })
        .catch((error) => {
            console.error('Error:', error);
        })

    });

});